"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupView = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useStore_1 = require("../../contexts/useStore/useStore");
const Search_1 = require("../../presenters/Search/Search");
const PanelGroup_1 = require("../../presenters/PanelGroup/PanelGroup");
const GroupView_styled_1 = require("./GroupView.styled");
const GroupView = ({ slug }) => {
    const { open } = (0, useStore_1.useStore)();
    const id = (0, react_1.useMemo)(() => parseInt(slug) || open('groups').where((group) => group.match(slug))[0]?.id, [slug, open]);
    const entity = (0, react_1.useMemo)(() => open('groups').find(id), [id, open]);
    return ((0, jsx_runtime_1.jsxs)(GroupView_styled_1.GroupViewStyled, { children: [(0, jsx_runtime_1.jsx)(Search_1.Search, { className: "search" }), entity && (0, jsx_runtime_1.jsx)(PanelGroup_1.PanelGroup, { group: entity })] }));
};
exports.GroupView = GroupView;
//# sourceMappingURL=GroupView.js.map